import FileTypeImageIcon from 'app/ui_v2/icons/FileTypeImageIcon';

import { Box, Button, IconButton, SxProps, Theme, useMediaQuery, useTheme } from '@mui/material';

import FileTypePdfIcon from '../../icons/FileTypePdfIcon';
import TrashIcon from '../../icons/TrashIcon';
import { FileInfo } from '../multi-file-uploader2/MultiFileUploader2';

export interface FileItemProps {
  item?: FileInfo;
  remove?: (id: string) => void;
  isLoading?: boolean;
  canRemoveFiles?: boolean;
  showIcon?: boolean;
  fontSize?: string;
}

const isImage = (name: string | undefined): boolean => {
  if (!name) {
    return false;
  }
  return name?.split('.').pop() !== 'pdf';
};

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    link: {
      color: `${theme.palette.primary.dark} !important`,
      overflowWrap: 'anywhere',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  };
};

export default function FileItem2(props: FileItemProps) {
  const { remove, item, isLoading, canRemoveFiles = true, showIcon = true, fontSize = '2rem' } = props;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const styles = getStyles(theme);

  if (!item) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      rowGap={'12px'}
      width="100%"
      alignItems="center"
      key={item.id}
      mb={2}
    >
      {showIcon && (
        <Box display="flex" mr={1.5} color={theme.palette.primary.dark}>
          {isImage(item?.name) && <FileTypeImageIcon />}
          {!isImage(item?.name) && <FileTypePdfIcon />}
        </Box>
      )}
      <Box display="flex" flexGrow="1" overflow="hidden" textOverflow="ellipsis" mr={1.5} fontSize={fontSize}>
        {item.url && (
          <Box
            component="a"
            rel="noopener noreferrer"
            target="_blank"
            href={item.previewUrl || item.url}
            sx={styles.link}
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            {item.name}
          </Box>
        )}
        {!item.url && item.name && (
          <Box sx={styles.link} textAlign={{ xs: 'center', sm: 'left' }}>
            {item.name}
          </Box>
        )}
      </Box>
      {remove && canRemoveFiles && (
        <>
          {matches && (
            <Button
              variant="outlined"
              className="error"
              disabled={isLoading}
              onClick={() => remove(item.documentId || item.uppyId)}
            >
              Delete
            </Button>
          )}
          {!matches && (
            <IconButton
              aria-label="Delete"
              className="error"
              disabled={isLoading}
              onClick={() => remove(item.documentId || item.uppyId)}
            >
              <TrashIcon />
            </IconButton>
          )}
        </>
      )}
    </Box>
  );
}
